module.exports = __webpack_public_path__ + "static/media/drdiary_01.188a58c8.png";